import React from "react";
import "./index.css";

function DecisionSummary({ noChangeNeeded, needsAdjustment, needsRemoval, notReviewed }) {
  return (
    <div className="decisionSummary">
      <li>No change needed : {noChangeNeeded}</li>
      <li>Needs adjustment : {needsAdjustment}</li>
      <li>Needs removal : {needsRemoval}</li>
      <li>Not reviewed : {notReviewed}</li>
    </div>
  );
}

export default DecisionSummary;
